/**
 * Mobile App Utilities
 * Helper functions for mobile app integration
 */

// Check if the request is coming from the mobile app
export const isMobileApp = () => {
  // First check if running in Capacitor (most reliable for native apps)
  if (typeof window !== 'undefined' && window.Capacitor !== undefined) {
    return true;
  }
  
  // Fallback checks for other mobile app scenarios
  const userAgent = navigator.userAgent || '';
  const urlParams = new URLSearchParams(window.location.search);
  
  return (
    userAgent.includes('NerdAIMobile') || 
    urlParams.get('source') === 'mobile_app' ||
    localStorage.getItem('mobile_app_session') === 'true'
  );
};

// Set mobile app session flag
export const setMobileAppSession = (isMobile) => {
  if (isMobile) {
    localStorage.setItem('mobile_app_session', 'true');
  } else {
    localStorage.removeItem('mobile_app_session');
  }
};

// Check if current device is mobile (browser)
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Generate deep link URL for mobile app
export const generateDeepLink = (path, params = {}) => {
  const baseUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
  const url = new URL(path, baseUrl);
  
  Object.keys(params).forEach(key => {
    url.searchParams.set(key, params[key]);
  });
  
  return url.toString();
};

// Open webapp from mobile app for subscription
export const openSubscribePage = (token) => {
  const baseUrl = window.location.origin;
  const subscribeUrl = `${baseUrl}/pricing?token=${encodeURIComponent(token)}&source=mobile_app`;
  
  // This will open in the device's default browser
  window.open(subscribeUrl, '_blank');
};

// Handle mobile app authentication token from URL
export const handleMobileAuthToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const source = urlParams.get('source');
  
  if (token && source === 'mobile_app') {
    localStorage.setItem('token', token);
    setMobileAppSession(true);
    
    // Clean up URL
    window.history.replaceState({}, document.title, window.location.pathname);
    
    return true;
  }
  
  return false;
};

export default {
  isMobileApp,
  setMobileAppSession,
  isMobileDevice,
  generateDeepLink,
  openSubscribePage,
  handleMobileAuthToken
};
